import React, { useContext } from "react";
import { UserContext } from "../context/UserContext";

export const useUser = () => {
    const context = useContext(UserContext);
    if (!context) {
      throw new Error('UserContext must be used within a CommonProvider');
    }
    return context;
};